'use client';

import { Tabs, Tab, Button } from '@mui/material';
import Link from 'next/link';
import { FC } from 'react';

import { useTranslations } from '../../../hooks/use-translations';
import { useRouter } from '../../../i18n/routing';
import { ArrowIcon } from '../../icons';

import style from './NavigationTabs.module.scss';

export type TabItemProps = {
  readonly name: string;
  readonly code: string;
  readonly link?: string;
  readonly demo?: boolean;
};

export type NavigationTabsProps = {
  tabs: readonly TabItemProps[];
  activeTab: string;
  rightLink?: {
    title?: string;
    link: string;
  };
  onClickTab?: (tabCode: string) => void;
};

export const NavigationTabs: FC<NavigationTabsProps> = ({ onClickTab, activeTab, tabs, rightLink }) => {
  const t = useTranslations('navigationTabs');
  const router = useRouter();

  return (
    <div className={style.NavigationTabsContent}>
      <Tabs
        className={style.NavigationTabs}
        value={activeTab}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
      >
        {tabs.map((tab) => (
          <Tab
            className={tab.demo ? 'demoLink' : undefined}
            value={tab.code}
            key={tab.code}
            icon={<ArrowIcon />}
            iconPosition="start"
            onClick={() => onClickTab?.(tab.code)}
            label={tab.link ? <Link href={tab.link}>{tab.name}</Link> : <span>{tab.name}</span>}
          />
        ))}
      </Tabs>

      {rightLink && (
        <Button variant="text" fullWidth={false} onClick={() => router.push(rightLink?.link)} sx={{ fontSize: '20px' }}>
          {rightLink.title ?? t('backBtn')}
        </Button>
      )}
    </div>
  );
};
